import { render, staticRenderFns } from "./landing-comunicados.vue?vue&type=template&id=327e75af&"
import script from "./landing-comunicados.vue?vue&type=script&lang=js&"
export * from "./landing-comunicados.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports